<div class="help-container">
  <div class="help-card">
    <!-- Header Section -->
    <div class="help-header">
      <div class="logo-container">
        <img class="logo" src="/assets/img/fleetoperate_logo.jpg" alt="FleetOperate Logo" />
      </div>
    </div>

    <!-- Content Section -->
    <div class="help-content">
      <!-- Support Icon -->
      <div class="support-icon">
        <mat-icon class="large-icon">support_agent</mat-icon>
      </div>

      <!-- Title -->
      <h1 class="help-title">Need Assistance?</h1>
      
      <!-- Description -->
      <p class="help-description">
        Our dedicated support team is here to help you with any questions or concerns you may have.
      </p>

      <!-- Contact Information -->
      <div class="contact-section">
        <div class="contact-item">
          <mat-icon class="contact-icon">email</mat-icon>
          <div class="contact-details">
            <span class="contact-label">Email us at</span>
            <a href="mailto:support@fleetoperate.com" class="contact-link">
              support@fleetoperate.com
            </a>
          </div>
        </div>
      </div>

      <!-- Success message -->
      <div class="help-message">
        <mat-icon class="message-icon">check_circle_outline</mat-icon>
        <span>We'll get back to you as soon as possible!</span>
      </div>
    </div>

    <!-- Action Section -->
    <div class="help-actions">
      <button
        mat-flat-button
        color="primary"
        class="modern-button"
        type="submit"
        (click)="onNavigateToSignIn()"
      >
        <mat-icon>arrow_back</mat-icon>
        Back to Sign In
      </button>
    </div>
  </div>
</div>

